import { observer } from "mobx-react-lite";
import type React from "react";
import { useCallback } from "react";
import { XStack } from "tamagui";
import { Body } from "../../../../ui/Body";
import { Label } from "../../../../ui/Label";
import type ExpenseModuleModel from "../../ExpenseModuleModel";
import type { CalculatorState } from "../Calculator";
import { scrollIntoViewWithoutOverlay } from "./AddExpenseFormSplitRow";
import type { ExpenseFormState } from "./ExpenseFormState";

export const AddExpenseFormAmount: React.FC<{
  module: ExpenseModuleModel;
  calculatorState: CalculatorState;
  formState: ExpenseFormState;
}> = observer(({ module, calculatorState, formState }) => {
  const inputKey = "amount";
  const selected = inputKey === calculatorState.inputKey;

  const openCalculator = useCallback(() => {
    calculatorState.setExpanded(
      true,
      inputKey,
      String(Number.parseFloat(formState.amount.toFixed(4))),
      (value, _readable) => {
        if (value !== undefined) {
          formState.setAmount(value);
        }
      },
    );
  }, [formState, calculatorState]);

  return (
    <XStack
      padding="$large"
      backgroundColor={"$backgroundBlock"}
      justifyContent="space-between"
      alignItems="center"
      outlineColor={"$primary"}
      outlineWidth={calculatorState.inputKey === inputKey ? 1 : 0}
      outlineStyle="solid"
      outlineOffset={-2}
      onPress={(e) => {
        e.stopPropagation();

        if (selected) {
          calculatorState.setExpanded(false);
          return;
        }

        const element = e.target as unknown as HTMLDivElement;
        scrollIntoViewWithoutOverlay(element, 20);

        openCalculator();
      }}
    >
      <Label>Amount</Label>
      <Body>
        {inputKey === calculatorState.inputKey
          ? calculatorState.readable
          : module.currencyFormatter.format(formState.amount.toNumber())}
      </Body>
    </XStack>
  );
});
